import styled from '@emotion/styled';

export const Container = styled.main`
	display: flex;
	flex-direction: column;
	gap: 8rem;
	max-width: 84.4rem;
	width: 100%;
	margin: 0 auto;
	padding-top: 8rem;
	@media screen and (max-width: 900px) {
		padding: 8rem 2rem 0rem 2rem;
	}
`;
export const ContentBox = styled.div`
	display: flex;
	flex-direction: column;
	gap: 2.4rem;
`;

export const ContentTitle = styled.p`
	color: #212529;
	font-size: ${(props) => props.theme.fontSize.sizeXl || '2.4rem'};
	font-weight: ${(props) => props.theme.fontWeight.weightSemi || '600'};
	line-height: 130%;
	letter-spacing: -0.6px;
`;

export const BasicInfoButtonBox = styled.div`
	display: flex;
	gap: 0.8rem;
	height: 4.4rem;
`;
export const BasicInfo = styled.ul`
	display: flex;
	flex-direction: column;
	gap: 0.8rem;
	font-size: 1.6rem;
	font-weight: 400;
	line-height: 100%;
	letter-spacing: -0.6px;
	color: #212529;
	li {
		position: relative;
		padding-left: 1.5rem;
		&::after {
			content: '';
			position: absolute;
			top: calc(0.8em - 7px);
			left: 0;
			background-color: currentColor;
			width: 4px;
			height: 4px;
			border-radius: 50%;
		}
	}
`;

export const BlueButton = styled.button`
	display: flex;
	justify-content: center;
	align-items: center;
	padding: 0rem 1.2rem;
	gap: 0.2rem;
	height: 100%;
	background-color: ${(props) => props.theme.colors.primary400};
	color: #fff;
	font-size: 1.6rem;
	font-weight: 400;
	line-height: 100%;
	letter-spacing: -0.6px;
	border: 1px solid ${(props) => props.theme.colors.primary400};
	min-width: 14rem;
	max-width: 18rem;
	width: 100%;
	cursor: pointer;
`;

export const WhiteButton = styled(BlueButton)`
	background-color: #fff;
	color: ${(props) => props.theme.colors.primary400};
`;
export const Table = styled.div`
	display: grid;
	grid-template-columns: 18.8rem 15rem 16.6rem 16.6rem 16.6rem;
	grid-auto-rows: minmax(40px, auto);
	overflow: auto;
	.item2 {
		grid-column-start: 1;
		grid-column-end: 3;
	}
	.item3 {
		grid-row-start: 2;
		grid-row-end: 4;
	}
	.item4 {
		grid-row-start: 4;
		grid-row-end: 6;
	}
	.item5 {
		grid-column-start: 3;
		grid-row-start: 4;
		grid-row-end: 6;
	}
	.item6 {
		grid-row-start: 6;
		grid-column-start: 1;
		grid-column-end: 3;
	}
	.item7 {
		grid-row-start: 6;
		grid-column-start: 3;
		grid-column-end: 6;
	}
`;

export const HighlightBox = styled.div`
	display: flex;
	gap: 1rem;
	padding: 2rem;
	background-color: #f1f3f5;
	font-size: 1.8rem;
	font-weight: 600;
	line-height: 130%;
	letter-spacing: -0.6px;
	.point {
		color: #47a3f3;
	}
`;

export const TableHeadCell = styled.div`
	display: flex;
	align-items: center;
	background-color: #00377b;
	color: white;
	padding: 10px 15px;
	text-align: left;
	border-right: 2px solid white;
	font-size: ${(props) => props.theme.fontSize.sizeMd};
	font-weight: ${(props) => props.theme.fontWeight.weightMedium};
	line-height: 150%;
	&.center {
		justify-content: center;
	}
`;

export const TableCell = styled.div`
	display: flex;
	align-items: center;
	background-color: #f1f3f5;
	padding: 10px 15px;
	border-right: 2px solid white;
	border-bottom: 2px solid white;
	font-size: ${(props) => props.theme.fontSize.sizeMd};
	font-weight: ${(props) => props.theme.fontWeight.weightRegular};
	line-height: 140%;
	letter-spacing: -0.6px;
	color: #212529;
	&.point {
		color: #01337d;
		font-weight: ${(props) => props.theme.fontWeight.weightBold};
	}
	&.center {
		justify-content: center;
	}
	&.min-height {
		min-height: 5.2rem;
	}
`;

export const PositionCell = styled(TableCell)`
	color: #00377b;
	font-weight: ${(props) => props.theme.fontWeight.weightBold};
`;

export const PaymentBox = styled.div`
	display: grid;
	grid-template-columns: minmax(auto, 26.9rem) auto;
	grid-auto-rows: minmax(52px, auto);
`;

export const PaymentContentName = styled.div`
	display: flex;
	justify-content: flex-start;
	align-items: center;
	background-color: ${(props) => props.theme.colors.primary400};
	color: white;
	padding: 0.8rem 1.2rem;
	min-height: 5.2rem;
	border: 1px solid #fff;
	font-size: 1.6rem;
	font-weight: 500;
	line-height: 150%;
`;

export const PaymentContent = styled(PaymentContentName)`
	background-color: #f1f3f5;
	color: #212529;

	&.danger {
		color: ${(props) => props.theme.colors.red600};
	}
`;
